import { post } from ".";

export const list: () => any = () => {
  const request = {
    subUrl: "visittypes/search",
  };
  return post(request);
};

export default { list };
